import harjavalta from './harjavalta';
import kk from './kristiinankaupunki';
import pori_kesk from './pori_kesk';
import pori_lavia from './pori_lavia';
import pori_noor from './pori_noor';
import pori_repo from './pori_repo';
import muu from './muu';
import oma_math from "./oma_math";

const formulas = {
  harjavalta,
  kk,
  pori_kesk,
  pori_lavia,
  pori_noor,
  pori_repo,
  muu,
}

const investiontiKategoriat = [
  { min: 0, max: 10, hinta: 6400 },
  { min: 10, max: 20, hinta: 8000 },
  { min: 20, max: 35, hinta: 9000 },
  { min: 35, max: 75, hinta: 12000 },
  { min: 75, max: 100, hinta: 12000 },
  { min: 100, max: 105, hinta: 12000 },
  { min: 105, max: 140, hinta: 15000 },
  { min: 140, max: 200, hinta: 15000 },
  { min: 200, max: 250, hinta: 17000 },
  { min: 250, max: 275, hinta: 18000 },
  { min: 275, max: 400, hinta: 25000 },
  { min: 400, max: 600, hinta: 25000 },
  { min: 600, max: 800, hinta: 30000 },
  { min: 800, max: 1200, hinta: 35000 },
  { min: 1200, max: 1400, hinta: 35000 },
];

const parametrit = {
  co2_per_mwh: 19,
}

const kaavat = `
kaytettava_korko = hae_kaytettava_korko(rakennustyyppi)

energiakulutus_vuodessa = energia_tarve

muuttuvat_kustannukset_vuodessa = energiakulutus_vuodessa * energiaMaksu

kayttoonottokustannukset = investointi + liittymismaksu

korot = laske_korot(kayttoonottokustannukset, kaytettava_korko, laina_aika)
paaomakustannukset = korot + kayttoonottokustannukset
paaomakustannukset_vuodessa = paaomakustannukset / kayttoika

kiinteat_kustannukset_vuodessa = tehomaksu

kayttokustannukset_vuodessa = kiinteat_kustannukset_vuodessa + muuttuvat_kustannukset_vuodessa
kayttokustannukset_mwh = kayttokustannukset_vuodessa / energiakulutus_vuodessa

energia_kokonaiskustannukset_vuodessa = kayttokustannukset_vuodessa + paaomakustannukset_vuodessa
energia_kokonaiskustannukset_mwh = energia_kokonaiskustannukset_vuodessa / energia_tarve

kustannukset_kayttoialle = energia_kokonaiskustannukset_vuodessa * kayttoika

co2_vuodessa = energiakulutus_vuodessa * co2_per_mwh

alkaen = (liittymismaksu + investointi) / 5 / 12
`;



export default {
  investointi(teho) {
    const kategoria = investiontiKategoriat.find(k => teho > k.min && teho <= k.max);
    return kategoria.hinta;
  },
  liittymismaksu(sijainti, rakennustyyppi, teho, liittymisetaisyys) {
    return formulas[sijainti].liittymismaksu(rakennustyyppi, teho, liittymisetaisyys);
  },
  tehomaksu(sijainti, rakennustyyppi, teho) {
    return formulas[sijainti].tehomaksu(rakennustyyppi, teho);
  },
  energiamaksu(sijainti, rakennustyyppi) {
    return formulas[sijainti].energiamaksu(rakennustyyppi);
  },

  laske(sijainti, rakennustyyppi, teho, energiaKulutus, liittymisetaisyys) {
    const liittymismaksu = this.liittymismaksu(sijainti, rakennustyyppi, teho, liittymisetaisyys);
    const tehomaksu = this.tehomaksu(sijainti, rakennustyyppi, teho);
    const energiaMaksu = this.energiamaksu(sijainti, rakennustyyppi);
    const investointi = this.investointi(teho);

    const scope = {
      liittymismaksu,
      rakennustyyppi,
      teho,
      tehomaksu,
      energiaMaksu,
      investointi,
      energia_tarve: energiaKulutus, ...parametrit,
    };
    oma_math().evaluate(kaavat, scope);
    return scope;
  },
}
